// What used to ride on the floating Jabberr's flag: a meeting that saved or needs attention, and a reply that
// needs attention. One banner across the top of the main area, with Open and Dismiss. "Reply ready" is left to
// the sidebar's finished-thread marks.
import { useNavigate } from 'react-router';
import { useCompanion } from '../state/companion.js';
import { useMeetingRecorder } from '../state/meeting-recorder.js';

export function NoticeBanner(): React.ReactElement | null {
  const { notice: pageNotice, setNotice } = useCompanion();
  const meetings = useMeetingRecorder();
  const navigate = useNavigate();
  const notice = meetings.notice ?? (pageNotice?.tone === 'attention' ? pageNotice : null);
  if (!notice) return null;
  const fromMeeting = meetings.notice !== null && notice.id === meetings.notice.id;
  const open = (): void => {
    if (fromMeeting) {
      meetings.acknowledge();
      if (notice.href) navigate(notice.href);
      else meetings.reveal();
    } else if (notice.onAcknowledge) notice.onAcknowledge();
    else setNotice(null);
  };
  const dismiss = (): void => {
    if (fromMeeting) meetings.acknowledge();
    else setNotice(null);
  };
  return (
    <div className={`mention-banner notice-banner ${notice.tone}`} role="status" aria-live="polite">
      <div className="mention-banner-main">
        <span>
          <strong>{notice.label}</strong>
          {notice.detail ? ` · ${notice.detail}` : ''}
        </span>
      </div>
      <span className="mention-banner-actions">
        <button type="button" className="link-btn" onClick={open}>Open</button>
        <button type="button" className="link-btn" onClick={dismiss}>Dismiss</button>
      </span>
    </div>
  );
}
